<dx-tabs [dataSource]="outerTabs"
         [(selectedIndex)]="selectedOuterTab"
         selectionMode="single"
         (onItemClick)="onOuterTabChange($event)"></dx-tabs>

<div [hidden]="selectedOuterTab !== 0">

<div></div>

<div class="supplier-tab-toolbar d-flex flex-row align-items-center mb-2">
  <dx-button *ngIf="renderNewSupplierButton()" stylingMode="text" [disabled]="updateLock || readOnly('supplierNew')" type="default" text="{{ 'Neuer Lieferant' | translate }}" (onClick)="openNewSupplier()"></dx-button>

  <div *ngIf="!templateView || showDragHandle" class="ms-auto">
    <np-inputControl [(model)]="product"
                     [showLinkButtons]="showLinkButtons"
                     [showPlaceLabel]="true"
                     [suppressTranslation]="true"
                     [suppressLabel]="true"
                     [suppressToolTip]="true"
                     [(selectedElement)]="selectedElement"
                     (elementSelected)="null"
                     (onValueChanged)="update($event)"
                     labelText="{{ 'HauptLieferant' | translate }}"
                     field="MAINSUPPLIER_ID"
                     [showDragHandle]="showDragHandle"
                     [dragFilter]="dragFilter"
                     (excelElementDropped)="excelElementDrop($event)">
      <div slot="content" class="contentSlot">
        <dx-select-box width="225"
                       [items]="supplierNames"
                       [value]="mainSupplierName"
                       (onSelectionChanged)="mainSupplierChanged($event)">
        </dx-select-box>
      </div>
    </np-inputControl>
  </div>
</div>

<dx-popup [width]="440"
          [height]="'auto'"
          [showTitle]="true"
          title="{{ 'Neuer Lieferant' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="newSupplierPopupVisible"
          contentTemplate="newSupplierContent">
  <div *dxTemplate="let data of 'newSupplierContent'">
    <div class="mb-3">
      <label class="d-block mb-1">{{ 'Name' | translate }}</label>
      <dx-text-box [(value)]="newSupplierName" valueChangeEvent="input"></dx-text-box>
    </div>
    <div class="mb-3">
      <label class="d-block mb-1">{{ 'Nummer' | translate }}</label>
      <dx-text-box [(value)]="newSupplierId" valueChangeEvent="input"></dx-text-box>
    </div>
    <div class="d-flex justify-content-end gap-2">
      <dx-button stylingMode="text" text="{{ 'Abbrechen' | translate }}" (onClick)="newSupplierPopupVisible = false"></dx-button>
      <dx-button stylingMode="contained" type="default" text="{{ 'Anlegen' | translate }}" [disabled]="!canConfirmNewSupplier || readOnly('supplierNew')" (onClick)="confirmNewSupplier()"></dx-button>
    </div>
  </div>
</dx-popup>

<dx-tab-panel [dataSource]="supplierGroups"
              [(selectedIndex)]="selectedSupplierTabIndex"
              [swipeEnabled]="false"
              [animationEnabled]="false"
              [showNavButtons]="true"
              [scrollByContent]="true"
              noDataText="{{ 'keine Lieferanten' | translate }}">
  <div *dxTemplate="let group of 'title'">
    {{ group.name }}
  </div>
  <div *dxTemplate="let group of 'item'">

<dx-data-grid [dataSource]="group.items"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [allowColumnResizing]="true"
              noDataText="{{ 'keine Lieferanten' | translate }}"
              [showBorders]="true"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowRemoved)="delete($event)"
              [masterDetail]="{ enabled: true, template: 'detail' }"
              (onContentReady)="onContentReady()"
              [customizeColumns]="customizeColumns">

  <dxo-editing mode="cell" [allowUpdating]="!readOnly('supplierUpdate')" [allowDeleting]="allowDeleting && !readOnly('supplierDelete')" [useIcons]="true">
    <dxo-texts confirmDeleteMessage="" confirmDeleteTitle=""></dxo-texts>
  </dxo-editing>

  <dxo-state-storing [enabled]="true" type="localStorage" storageKey="suppliersStateNewUIV3"></dxo-state-storing>

  <dxi-column dataField="order" caption="{{ 'Order' | translate }}" [width]="70" [allowEditing]="true" cellTemplate="orderTemplate" editCellTemplate="orderTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'orderTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.order != null"
                       [suppressTranslation]="true"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="null"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Order' | translate }}"
                       field="SUPPLIER_ORDER"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="false"
                       [dragFilter]="dragFilter">

        <div slot="content" class="contentSlot">
          <dx-number-box *ngIf="showLinkButtons"
                         class="inDataGrid"
                         [(value)]="supplier.data.order"
                         [min]="1"
                         [showSpinButtons]="!hasSupplierFieldLinked(supplier?.data?.order?.toString())"
                         [readOnly]="hasSupplierFieldLinked(supplier?.data?.order?.toString()) || readOnly('SUPPLIER_ORDER')"
                         [showClearButton]="false"
                         valueChangeEvent="focusout"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_ORDER', supplier?.data?.order?.toString())">
          </dx-number-box>
          <dx-number-box *ngIf="!showLinkButtons"
                         class="inDataGrid"
                         [(value)]="supplier.data.order"
                         [min]="1"
                         [showSpinButtons]="!templateView"
                         [readOnly]="readOnly('SUPPLIER_ORDER')"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_ORDER', supplier?.data?.order?.toString())">
          </dx-number-box>
        </div>

      </np-inputControl>
    </div>

  </div>



  <dxi-column dataField="supplierId" caption="{{ 'Nummer' | translate }}" [allowEditing]="true" cellTemplate="supplierIdTemplate" editCellTemplate="supplierIdTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'supplierIdTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.supplierId?.length > 0"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Nummer' | translate }}"
                       field="SUPPLIER_ID"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-text-box [(value)]="supplier.data.supplierId"
                       [readOnly]="readOnlyForLinkedFields('SUPPLIER_ID', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_ID')"
                       [showClearButton]="!readOnlyForLinkedFields('SUPPLIER_ID', supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_ID', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_ID', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="supplierName" caption="{{ 'Name' | translate }}" [allowEditing]="true" cellTemplate="supplierNameTemplate" editCellTemplate="supplierNameTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'supplierNameTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.supplierName?.length > 0"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Name' | translate }}"
                       field="SUPPLIER_NAME"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-text-box [(value)]="supplier.data.supplierName"
                       [readOnly]="readOnlyForLinkedFields('SUPPLIER_NAME', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_NAME')"
                       [showClearButton]="showClearButton('SUPPLIER_NAME', supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_NAME', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_NAME', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="deliveryTime" caption="{{ 'Lieferzeit' | translate }}" [allowEditing]="true" cellTemplate="deliveryTimeTemplate" editCellTemplate="deliveryTimeTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'deliveryTimeTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.deliveryTime  != null"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Lieferzeit' | translate }}"
                       field="SUPPLIER_DELIVERY_TIME"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box class="inDataGrid"
                         [(value)]="supplier.data.deliveryTime"
                         [showSpinButtons]="!templateView"
                         [readOnly]="readOnly('SUPPLIER_DELIVERY_TIME')"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DELIVERY_TIME', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_DELIVERY_TIME', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="price" caption="{{ 'Preis' | translate }}" [allowEditing]="true" cellTemplate="priceTemplate" editCellTemplate="priceTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'priceTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.price  != null"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Preis' | translate }}"
                       field="SUPPLIER_PRICE"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box class="inDataGrid"
                         [(value)]="supplier.data.price"
                         [readOnly]="readOnly('SUPPLIER_PRICE')"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRICE', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_PRICE', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="priceType" caption="{{ 'Preistyp' | translate }}" [allowEditing]="true" cellTemplate="priceTypeTemplate" editCellTemplate="priceTypeTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'priceTypeTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.priceType?.length > 0"
                       [suppressTranslation]="true"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Preistyp' | translate }}"
                       field="SUPPLIER_PRICE_TYPE"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-autocomplete validationMessagePosition="top"
                           [minSearchLength]="0"
                           [dataSource]="priceTypes"
                           [showClearButton]="false"
                           [showDropDownButton]="!readOnlyForLinkedFields('SUPPLIER_PRICE_TYPE', supplier?.data?.order?.toString())"
                           [(value)]="supplier.data.priceType"
                           [readOnly]="readOnlyForLinkedFields('SUPPLIER_PRICE_TYPE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PRICE_TYPE')"
                           valueChangeEvent="blur"
                           (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRICE_TYPE', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_PRICE_TYPE', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-autocomplete>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="discount" caption="{{ 'Rabatt' | translate }}" [allowEditing]="true" cellTemplate="discountTemplate" editCellTemplate="discountTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'discountTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.discount != null"
                       [suppressTranslation]="true"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Rabatt' | translate }}"
                       field="SUPPLIER_DISCOUNT"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box class="inDataGrid"
                         [(value)]="supplier.data.discount"
                         format="#0.##'%'"
                         [readOnly]="readOnlyForLinkedFields('SUPPLIER_DISCOUNT', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_DISCOUNT')"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DISCOUNT', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_DISCOUNT', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="scaleQuantity" caption="{{ 'Mengenstaffel' | translate }}" [allowEditing]="true" cellTemplate="scaleQuantityTemplate" editCellTemplate="scaleQuantityTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'scaleQuantityTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.scaleQuantity != null"
                       [suppressTranslation]="true"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'Mengenstaffel' | translate }}"
                       field="SUPPLIER_SCALE_QUANTITY"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-number-box class="inDataGrid"
                         [(value)]="supplier.data.scaleQuantity"
                         [readOnly]="readOnlyForLinkedFields('SUPPLIER_SCALE_QUANTITY', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_SCALE_QUANTITY')"
                         [showClearButton]="false"
                         (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_SCALE_QUANTITY', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_SCALE_QUANTITY', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>

      </np-inputControl>
    </div>

  </div>

  <dxi-column dataField="validFrom" caption="{{ 'gültig ab' | translate }}" [allowEditing]="true" cellTemplate="validFromTemplate" editCellTemplate="validFromTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'validFromTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.validFrom  != null"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'gültig ab' | translate }}"
                       field="SUPPLIER_VALID_FROM"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-date-box [(value)]="supplier.data.validFrom"
                       type="date"
                       [showClearButton]="showClearButton('SUPPLIER_VALID_FROM', supplier?.data?.order?.toString())"
                       [readOnly]="readOnlyForLinkedFields('SUPPLIER_VALID_FROM', supplier?.data?.order?.toString())  || readOnly('SUPPLIER_VALID_FROM')"
                       displayFormat="dd.MM.yyyy"
                       (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_VALID_FROM', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_VALID_FROM', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>
      </np-inputControl>
    </div>
  </div>


  <dxi-column dataField="validUntil" caption="{{ 'gültig bis' | translate }}" [allowEditing]="true" cellTemplate="validUntilTemplate" editCellTemplate="validUntilTemplate"></dxi-column>
  <div *dxTemplate="let supplier of 'validUntilTemplate'">

    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="showLinkButtons"
                       [showPlaceLabel]="supplier?.data?.validUntil  != null"
                       [suppressToolTip]="true"
                       [suppressLabel]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                       (onValueChanged)="update($event)"
                       labelText="{{ 'gültig bis' | translate }}"
                       field="SUPPLIER_VALID_UNTIL"
                       [system]="supplier?.data?.order?.toString()"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">

        <div slot="content" class="contentSlot">
          <dx-date-box [(value)]="supplier.data.validUntil"
                       type="date"
                       [showClearButton]="showClearButton('SUPPLIER_VALID_UNTIL', supplier?.data?.order?.toString())"
                       [readOnly]="readOnlyForLinkedFields('SUPPLIER_VALID_UNTIL', supplier?.data?.order?.toString())  || readOnly('SUPPLIER_VALID_UNTIL')"
                       displayFormat="dd.MM.yyyy"
                       (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_VALID_UNTIL', supplier?.data?.order?.toString())">
            <dx-validator *ngIf="!templateView"
                          validationGroup="SUPP"
                          (onInitialized)="validationService.startAutomaticValidation($event)">
              <dxi-validation-rule type="async" [validationCallback]="validationService.validateField('SUPPLIER_VALID_UNTIL', supplier?.data?.order?.toString())"></dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>
      </np-inputControl>
    </div>
  </div>



  <dxi-column [calculateCellValue]="calculateCurrentValue"
              caption="{{ 'Aktuell' | translate }}"
              [allowEditing]="false"
              [allowSorting]="true"
              [allowFiltering]="true"></dxi-column>

  <dxi-column type="buttons" [width]="60" [allowResizing]="false" [allowReordering]="false">
    <dxi-button name="delete"></dxi-button>
    <dxi-button icon="add"
                hint="{{ 'Weiteren Eintrag hinzufügen' | translate }}"
                [visible]="canAddSupplierItem"
                [disabled]="readOnly('supplierNew')"
                [onClick]="addSupplierItemFromRow"></dxi-button>
  </dxi-column>

  <div *dxTemplate="let supplier of 'detail'">
    <div class="supplier-detail-root">
      <div class="supplier-detail-panel container-fluid px-0">
        <div class="row g-4">

          <div class="col-12 col-lg-6">
            <div class="supplier-detail-section-header">
              {{ 'Produktinformationen' | translate }}
              <span class="supplier-detail-section-subtitle">({{ 'des Lieferanten' | translate }})</span>
            </div>

            <div class="supplier-detail-field supplier-detail-textarea">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="supplier?.data?.supplierProductDescription?.length > 0"
                [suppressTranslation]="true"
                [suppressToolTip]="true"
                [(selectedElements)]="selectedElements"
                (elementSelected)="null"
                (onValueChanged)="update($event)"
                labelText="{{ 'Produktbeschreibung' | translate }}"
                field="SUPPLIER_PRODUCT_DESC"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                  <dx-text-area
                    [(value)]="supplier.data.supplierProductDescription"
                    [height]="180"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_PRODUCT_DESC', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PRODUCT_DESC')"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRODUCT_DESC', supplier?.data?.order?.toString())">
                  </dx-text-area>
                </div>
              </np-inputControl>
            </div>

            <div class="supplier-detail-field">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="supplier?.data?.pid?.length > 0"
                [suppressTranslation]="true"
                [suppressToolTip]="true"
                [(selectedElements)]="selectedElements"
                (elementSelected)="null"
                (onValueChanged)="update($event)"
                labelText="{{ 'Produktnummer' | translate }}"
                field="PID"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)">

                <div slot="content" class="contentSlot">
                  <dx-text-box
                    [(value)]="supplier.data.pid"
                    [readOnly]="readOnlyForLinkedFields('PID', supplier?.data?.order?.toString()) || readOnly('PID')"
                    [showClearButton]="showClearButton('PID', supplier?.data?.order?.toString())"
                    (onValueChanged)="update($event, null, supplier.data, 'PID', supplier?.data?.order?.toString())">
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-8">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.internationalId"
                    [suppressToolTip]="true"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="null"
                    (onValueChanged)="update($event)"
                    labelText="{{ 'International ID' | translate }}"
                    field="SUPPLIER_INTERNATIONAL_ID"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)">

                    <div slot="content" class="contentSlot">
                      <dx-text-box
                        [(value)]="supplier.data.internationalId"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_INTERNATIONAL_ID', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_INTERNATIONAL_ID')"
                        [showClearButton]="showClearButton('SUPPLIER_INTERNATIONAL_ID', supplier?.data?.order?.toString())"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_INTERNATIONAL_ID', supplier?.data?.order?.toString())">
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-4">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.internationalIdType"
                    [suppressToolTip]="true"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="null"
                    (onValueChanged)="update($event)"
                    labelText="{{ 'Typ' | translate }}"
                    field="SUPPLIER_INTERNATIONAL_ID_TYP"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)">

                    <div slot="content" class="contentSlot">
                      <dx-autocomplete
                        [minSearchLength]="0"
                        [dataSource]="internationalPidType"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_INTERNATIONAL_ID_TYP', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_INTERNATIONAL_ID_TYP')"
                        [showClearButton]="showClearButton('SUPPLIER_INTERNATIONAL_ID_TYP', supplier?.data?.order?.toString())"
                        [showDropDownButton]="!readOnlyForLinkedFields('SUPPLIER_INTERNATIONAL_ID_TYP', supplier?.data?.order?.toString())"
                        [(value)]="supplier.data.internationalIdType"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_INTERNATIONAL_ID_TYP', supplier?.data?.order?.toString())"
                        (onSelectionChanged)="updateFromAutocomplete($event, 'SUPPLIER_INTERNATIONAL_ID_TYP', supplier?.data?.order?.toString())">
                      </dx-autocomplete>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>

            <div class="supplier-detail-field">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="supplier?.data?.supplierProductDescriptionShort?.length > 0"
                [suppressTranslation]="true"
                [suppressToolTip]="true"
                labelText="{{ 'Kurzbeschreibung' | translate }}"
                field="SUPPLIER_DESC_SHORT"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)">

                <div slot="content" class="contentSlot">
                  <dx-text-box
                    [(value)]="supplier.data.supplierProductDescriptionShort"
                    [showClearButton]="showClearButton('SUPPLIER_DESC_SHORT', supplier?.data?.order?.toString())"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_DESC_SHORT', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_DESC_SHORT')"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DESC_SHORT', supplier?.data?.order?.toString())">
                  </dx-text-box>
                </div>

              </np-inputControl>
            </div>

            <div class="supplier-detail-field">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="supplier?.data?.discountGroupCode?.length > 0"
                [suppressTranslation]="true"
                [suppressToolTip]="true"
                [(selectedElements)]="selectedElements"
                (elementSelected)="null"
                (onValueChanged)="update($event)"
                labelText="{{ 'Rabattgruppencode' | translate }}"
                field="SUPPLIER_DISCOUNT_GROUP_CODE"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)">

                <div slot="content" class="contentSlot">
                  <dx-text-box
                    [(value)]="supplier.data.discountGroupCode"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_DISCOUNT_GROUP_CODE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_DISCOUNT_GROUP_CODE')"
                    [showClearButton]="showClearButton('SUPPLIER_DISCOUNT_GROUP_CODE', supplier?.data?.order?.toString())"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DISCOUNT_GROUP_CODE', supplier?.data?.order?.toString())">
                  </dx-text-box>
                </div>

              </np-inputControl>
            </div>

            <div class="row g-3 align-items-end">
              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="false"
                    [suppressPlaceLabel]="true"
                    [suppressContentWidth]="templateView"
                    labelText="{{ 'Auslaufprodukt' | translate }}"
                    field="SUPPLIER_DISCONTINUED_PRODUCT"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot supplier-detail-radio">
                      <np-booleanRadioGroup
                        [(value)]="supplier.data.discontinuedProduct"
                        [templateView]="templateView"
                        [fieldName]="validationService.fieldNames.supplierDiscontinuedProduct"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_DISCONTINUED_PRODUCT', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_DISCONTINUED_PRODUCT')"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DISCONTINUED_PRODUCT', supplier?.data?.order?.toString())"
                        validatorValidationGroup="SUPP">
                      </np-booleanRadioGroup>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.discontinuedDate"
                    labelText="{{ 'Auslaufdatum' | translate }}"
                    field="SUPPLIER_DISCONTINUED_DATE"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <dx-date-box
                        [(value)]="supplier.data.discontinuedDate"
                        type="date"
                        displayFormat="dd.MM.yyyy"
                        [showClearButton]="showClearButton('SUPPLIER_DISCONTINUED_DATE', supplier?.data?.order?.toString())"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_DISCONTINUED_DATE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_DISCONTINUED_DATE')"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_DISCONTINUED_DATE', supplier?.data?.order?.toString())">
                      </dx-date-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="supplier-detail-section-header">
              {{ 'Bestellinformationen' | translate }}
              <span class="supplier-detail-section-subtitle">({{ 'des Lieferanten' | translate }})</span>
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.priceAllocationUnitCode?.length > 0"
                    labelText="{{ 'Bestelleinheit' | translate }}"
                    field="SUPPLIER_PRICE_ALLOCATION_UNIT_CODE"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <np-dropdown-control
                        fieldName="SUPPLIER_PRICE_ALLOCATION_UNIT_CODE"
                        [systemKey]="supplier?.data?.order?.toString()"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_PRICE_ALLOCATION_UNIT_CODE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PRICE_ALLOCATION_UNIT_CODE')"
                        [templateView]="templateView"
                        [items]="unitDataSource"
                        [(value)]="supplier.data.priceAllocationUnitCode"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRICE_ALLOCATION_UNIT_CODE', supplier?.data?.order?.toString())"
                        (onCustomItemCreating)="onUnitCustomItemCreating($event, supplier.data, 'priceAllocationUnitCode')">
                      </np-dropdown-control>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.originalPriceAllocationUnitCode?.length > 0"
                    labelText="{{ 'Original Bestelleinheit' | translate }}"
                    field="SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <np-dropdown-control
                        fieldName="SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL"
                        [systemKey]="supplier?.data?.order?.toString()"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL')"
                        [templateView]="templateView"
                        [acceptCustomValue]="false"
                        [items]="originalUnitDataSource"
                        [(value)]="supplier.data.originalPriceAllocationUnitCode"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRICE_ALLOCATION_UNIT_CODE_ORIGINAL', supplier?.data?.order?.toString())">
                      </np-dropdown-control>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.pricingUnitCode?.length > 0"
                    labelText="{{ 'Preismenge' | translate }}"
                    field="SUPPLIER_PRICE_UNIT_CODE"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <dx-text-box
                        [(value)]="supplier.data.pricingUnitCode"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_PRICE_UNIT_CODE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PRICE_UNIT_CODE')"
                        [showClearButton]="showClearButton('SUPPLIER_PRICE_UNIT_CODE', supplier?.data?.order?.toString())"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PRICE_UNIT_CODE', supplier?.data?.order?.toString())">
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.minOrderAmount"
                    labelText="{{ 'Mindestbestellmenge' | translate }}"
                    field="SUPPLIER_MIN_ORDER_AMOUNT"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <dx-text-box
                        [(value)]="supplier.data.minOrderAmount"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_MIN_ORDER_AMOUNT', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_MIN_ORDER_AMOUNT')"
                        [showClearButton]="showClearButton('SUPPLIER_MIN_ORDER_AMOUNT', supplier?.data?.order?.toString())"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_MIN_ORDER_AMOUNT', supplier?.data?.order?.toString())">
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.orderIntervall"
                    labelText="{{ 'Bestellintervall' | translate }}"
                    field="SUPPLIER_ORDER_INTERVALL"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <dx-text-box
                        [(value)]="supplier.data.orderIntervall"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_ORDER_INTERVALL', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_ORDER_INTERVALL')"
                        [showClearButton]="showClearButton('SUPPLIER_ORDER_INTERVALL', supplier?.data?.order?.toString())"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_ORDER_INTERVALL', supplier?.data?.order?.toString())">
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>

            <div class="supplier-detail-subsection-header">
              {{ 'Verpackungsinformationen' | translate }}
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.contentUnitCode"
                    labelText="{{ 'Inhaltseinheit' | translate }}"
                    field="SUPPLIER_CONTENT_UNIT_CODE"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <np-dropdown-control
                        fieldName="SUPPLIER_CONTENT_UNIT_CODE"
                        [systemKey]="supplier?.data?.order?.toString()"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_CONTENT_UNIT_CODE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_CONTENT_UNIT_CODE')"
                        [templateView]="templateView"
                        [items]="unitDataSource"
                        [(value)]="supplier.data.contentUnitCode"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_CONTENT_UNIT_CODE', supplier?.data?.order?.toString())"
                        (onCustomItemCreating)="onUnitCustomItemCreating($event, supplier.data, 'contentUnitCode')">
                      </np-dropdown-control>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="supplier-detail-field mb-0">
                  <np-inputControl
                    [(model)]="product"
                    [showLinkButtons]="showLinkButtons"
                    [showPlaceLabel]="supplier?.data?.packingAmount"
                    labelText="{{ 'Verpackungsmenge' | translate }}"
                    field="SUPPLIER_PACKING_AMOUNT"
                    [system]="supplier?.data?.order?.toString()"
                    [showDragHandle]="showDragHandle"
                    [dragFilter]="dragFilter"
                    [(selectedElements)]="selectedElements"
                    (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)">

                    <div slot="content" class="contentSlot">
                      <dx-text-box
                        [(value)]="supplier.data.packingAmount"
                        [readOnly]="readOnlyForLinkedFields('SUPPLIER_PACKING_AMOUNT', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_PACKING_AMOUNT')"
                        [showClearButton]="showClearButton('SUPPLIER_PACKING_AMOUNT', supplier?.data?.order?.toString())"
                        (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_PACKING_AMOUNT', supplier?.data?.order?.toString())">
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>

            <div class="supplier-detail-subsection-header">
              {{ 'Grundpreisinformationen' | translate }}
            </div>

            <div class="supplier-detail-field mb-2">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="false"
                [suppressPlaceLabel]="true"
                [suppressContentWidth]="templateView"
                [(selectedElements)]="selectedElements"
                (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                labelText="{{ 'Ist Grundpreispflichtig' | translate }}"
                field="SUPPLIER_HAS_BASEPRICE_DUTY"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)">

                <div slot="content" class="contentSlot supplier-detail-radio">
                  <np-booleanRadioGroup
                    [(value)]="supplier.data.hasBasicPriceDuty"
                    [templateView]="templateView"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_HAS_BASEPRICE_DUTY', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_HAS_BASEPRICE_DUTY')"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_HAS_BASEPRICE_DUTY', supplier?.data?.order?.toString())">
                  </np-booleanRadioGroup>
                </div>
              </np-inputControl>
            </div>

            <div class="supplier-detail-field mb-2" *ngIf="supplier.data.hasBasicPriceDuty">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [(selectedElements)]="selectedElements"
                (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                [showPlaceLabel]="supplier?.data?.contentPackage?.length > 0"
                labelText="{{ 'Grundmengeneinheit' | translate }}"
                field="SUPPLIER_CONTENT_PACKAGE"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)">

                <div slot="content" class="contentSlot">
                  <np-dropdown-control
                    fieldName="SUPPLIER_CONTENT_PACKAGE"
                    [systemKey]="supplier?.data?.order?.toString()"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_CONTENT_PACKAGE', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_CONTENT_PACKAGE')"
                    [templateView]="templateView"
                    [items]="unitDataSource"
                    [(value)]="supplier.data.contentPackage"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_CONTENT_PACKAGE', supplier?.data?.order?.toString())"
                    (onCustomItemCreating)="onUnitCustomItemCreating($event, supplier.data, 'contentPackage')">
                  </np-dropdown-control>
                </div>
              </np-inputControl>
            </div>

            <div class="supplier-detail-field mb-2" *ngIf="supplier.data.hasBasicPriceDuty">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [(selectedElements)]="selectedElements"
                (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                [showPlaceLabel]="supplier?.data?.basicQuantityNumber != null"
                labelText="{{ 'Grundmenge' | translate }}"
                field="SUPPLIER_BASIC_QUANTITY"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)">

                <div slot="content" class="contentSlot">
                  <dx-number-box
                    [(value)]="supplier.data.basicQuantityNumber"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_BASIC_QUANTITY', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_BASIC_QUANTITY')"
                    [showClearButton]="showClearButton('SUPPLIER_BASIC_QUANTITY', supplier?.data?.order?.toString())"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_BASIC_QUANTITY', supplier?.data?.order?.toString())">
                  </dx-number-box>
                </div>
              </np-inputControl>
            </div>

            <div class="supplier-detail-field mb-0" *ngIf="supplier.data.hasBasicPriceDuty">
              <np-inputControl
                [(model)]="product"
                [showLinkButtons]="showLinkButtons"
                [(selectedElements)]="selectedElements"
                (elementSelected)="templateSelect($event, supplier?.data?.order?.toString())"
                [showPlaceLabel]="supplier?.data?.contentQuantityNumber != null"
                labelText="{{ 'Inhaltsmenge' | translate }}"
                field="SUPPLIER_CONTENT_QUANTITY"
                [system]="supplier?.data?.order?.toString()"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)">

                <div slot="content" class="contentSlot">
                  <dx-number-box
                    [(value)]="supplier.data.contentQuantityNumber"
                    [readOnly]="readOnlyForLinkedFields('SUPPLIER_CONTENT_QUANTITY', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_CONTENT_QUANTITY')"
                    [showClearButton]="showClearButton('SUPPLIER_CONTENT_QUANTITY', supplier?.data?.order?.toString())"
                    (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_CONTENT_QUANTITY', supplier?.data?.order?.toString())">
                  </dx-number-box>
                </div>
              </np-inputControl>
            </div>

            <np-price-preview *ngIf="supplier.data.price != null"
                              [price]="supplier.data.price"
                              currency="EUR"
                              [isNetPrice]="!supplier.data.priceType?.startsWith('gross_')"
                              [priceQuantity]="supplier.data.pricingUnitCode"
                              [orderUnit]="supplier.data.priceAllocationUnitCode"
                              [basicQuantity]="supplier.data.hasBasicPriceDuty ? supplier.data.basicQuantityNumber : null"
                              [contentQuantity]="supplier.data.contentQuantityNumber"
                              [contentPackage]="supplier.data.contentPackage"
                              [contentUnit]="supplier.data.contentUnitCode"
                              [showStandardPrice]="true"></np-price-preview>

            <hr *ngIf="supplier.data.price != null && loginService.hasAddonBauvista" />

            <div class="supplier-detail-subsection-header" *ngIf="loginService.hasAddonBauvista">
              {{ 'Bauvista' | translate }}
            </div>
            <div class="row g-3" *ngIf="loginService.hasAddonBauvista">
                <div class="supplier-detail-field mb-2">
                    <np-inputControl
                        [(model)]="product"
                        [showLinkButtons]="showLinkButtons"
                        [showPlaceLabel]="supplier?.data?.bauvistaArticleNumber"
                        labelText="{{ 'Bauvista Artikelnummer' | translate }}"
                        field="SUPPLIER_BAUVISTA_ARTICLE_NUMBER"
                        [system]="supplier?.data?.order?.toString()"
                        [showDragHandle]="showDragHandle"
                        [dragFilter]="dragFilter"
                        (excelElementDropped)="excelElementDrop($event)"
                        (onValueChanged)="update($event)">

                        <div slot="content" class="contentSlot">
                            <dx-text-box
                                [(value)]="supplier.data.bauvistaArticleNumber"
                                [readOnly]="readOnlyForLinkedFields('SUPPLIER_BAUVISTA_ARTICLE_NUMBER', supplier?.data?.order?.toString()) || readOnly('SUPPLIER_BAUVISTA_ARTICLE_NUMBER')"
                                [showClearButton]="showClearButton('SUPPLIER_BAUVISTA_ARTICLE_NUMBER', supplier?.data?.order?.toString())"
                                (onValueChanged)="update($event, null, supplier.data, 'SUPPLIER_BAUVISTA_ARTICLE_NUMBER', supplier?.data?.order?.toString())">
                            </dx-text-box>
                        </div>
                    </np-inputControl>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</dx-data-grid>

  </div>
</dx-tab-panel>

<div class="color5Text">
  <div *ngIf="loginService.currentCustomer.automaticValidation && !validationService.validationResult?.productSuppliersValid">
    <table>
      <tr *ngFor="let msg of validationService.validationResult?.suppliersMessages">
        <td>
          {{ msg | translate }}
        </td>
      </tr>
    </table>
  </div>
</div>

</div>

<div [hidden]="selectedOuterTab !== 1">
  <purchasingUnits [product]="product"
                   [units]="unitDataSource"
                   [customerId]="customerId"
                   [templateView]="templateView"
                   [showLinkButtons]="showLinkButtons"
                   [(exportMode)]="exportMode"
                   [(selectedElements)]="selectedElements"
                   [showDragHandle]="showDragHandle"
                   [dragFilter]="dragFilter"
                   (onValueChanged)="update($event)"
                   (elementSelected)="elementSelected.emit($event)"
                   (excelElementDropped)="excelElementDrop($event)"
                   (elementDeleted)="elementDeleted.emit($event)"></purchasingUnits>
</div>